export enum Views {
  Main,
  MultiEmail,
  Summary,
  Sent,
  InvitationErrors,
  BulkSent,
}
